import { Component } from 'react'
import { Icons, Box, Text } from 'stylewhere/components'
import styled from '@emotion/styled'
import { RowColumn } from 'stylewhere/api'

interface Props {
  column: RowColumn
  onReset: (field: string) => void
  onSearch: (field: string, value: string) => void
}

interface State {
  value: string
  searched: boolean
  searchable: boolean
}

export class TableColumn extends Component<Props> {
  timer?: any

  state: State = {
    value: '',
    searchable: false,
    searched: false
  }

  openSearchable = () => {
    this.setState({ searchable: true })
  }

  closeSearchable = () => {
    this.setState({ searchable: false })
  }

  onChange = (val) => {
    this.setState({ value: val, searched: false })
  }

  reset = () => {
    const { column, onReset } = this.props
    this.setState({ value: '', searched: false })
    onReset(column.field)
  }

  getIconType = () => {
    const { column } = this.props
    const { searchable, value, searched } = this.state
    if (!column.filterable) return 0
    if (searchable || value !== '') {
      if (searched) {
        return 2
      }
      if (value !== '') {
        return 1
      }
      return 0
    }
    return 1
  }

  destroyTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = undefined
    }
  }

  handleKeyUp = (field: string) => {
    this.destroyTimer()
    this.timer = setTimeout(() => {
      this.setState({ searched: true })
      this.props.onSearch(field, this.state.value)
    }, 500)
  }

  render() {
    const { column } = this.props
    const { value, searchable } = this.state
    const iconType = this.getIconType()
    const showSearch = searchable || value !== ''
    return (
      <Head
        bgGrey
        width={column.width ?? 160}
        row
        onClick={() => (!showSearch ? this.openSearchable() : {})}
        searched={showSearch}
        vcenter
      >
        {!showSearch ? (
          <Text style={{ flex: 1, textAlign: column.center ? 'center' : 'left' }}>{column.label}</Text>
        ) : (
          <SearchInput
            required={true}
            onChange={(e) => this.onChange((e.target as any).value)}
            type={'text'}
            autoFocus={true}
            height={20}
            value={value}
            onBlur={() => this.closeSearchable()}
            onKeyUp={() => this.handleKeyUp(column.field)}
          />
        )}
        {iconType === 1 && <Icons.Search width={20} height={20} />}
        {iconType === 2 && <Icons.Close width={20} height={20} onClick={this.reset} />}
      </Head>
    )
  }
}

const Head = styled(Box)<{ searched: boolean }>`
  padding-top: ${({ searched }) => (searched ? '3px' : '10px')};
  padding-bottom: ${({ searched }) => (searched ? '3px' : '10px')};
  padding-left: ${({ searched }) => (searched ? '3px' : '10px')};
  padding-right: 10px;
  border: 2px solid #ddd;
  border-left: 0px;
`

const SearchInput = styled.input`
  flex: 1;
  height: 34px;
  width: 100%;
  background-color: transparent;
  font-style: normal;
  font-weight: normal;
  color: #333333;
  font-size: 16px;
  line-height: 22px;
  padding-left: 7px;
  padding-right: 7px;
  :focus {
    box-shadow: none;
    outline: none;
    border: 0;
  }
`
